/** Canonical public legal route paths — shared by Account Popover, Public
 * Footer, and React Router registration (spec §43). */

export const PUBLIC_LEGAL_ROUTES = {
  privacy: '/privacy',
  terms: '/terms',
  refund: '/refund',
  billing: '/billing',
} as const

export type PublicLegalRouteKey = keyof typeof PUBLIC_LEGAL_ROUTES

export const PUBLIC_LEGAL_ROUTE_KEYS = Object.keys(PUBLIC_LEGAL_ROUTES) as PublicLegalRouteKey[]

export function publicLegalPath(key: PublicLegalRouteKey): string {
  return PUBLIC_LEGAL_ROUTES[key]
}

export function absolutePublicLegalUrl(key: PublicLegalRouteKey, origin: string = window.location.origin): string {
  return `${origin.replace(/\/+$/, '')}${PUBLIC_LEGAL_ROUTES[key]}`
}
